<template>
  <header class="v2-section-header">
    <div class="v2-section-header__text">
      <p v-if="eyebrow" class="v2-overline v2-section-header__eyebrow">{{ eyebrow }}</p>
      <component
        :is="level"
        :class="['v2-headline', `v2-headline--${size}`, 'v2-section-header__title']"
      >
        {{ title }}
      </component>
      <p v-if="description" class="v2-body v2-body--md v2-body--muted v2-section-header__description">
        {{ description }}
      </p>
    </div>
    <div v-if="$slots.actions" class="v2-section-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  name: "SectionHeader",
  props: {
    title: { type: String, required: true },
    eyebrow: { type: String, default: "" },
    description: { type: String, default: "" },
    size: {
      type: String,
      default: "display-md",
      validator: (v) => ["display-2xl", "display-xl", "display-lg", "display-md", "display-sm"].includes(v),
    },
    level: {
      type: String,
      default: "h2",
      validator: (v) => ["h1", "h2", "h3", "h4", "h5", "h6"].includes(v),
    },
  },
};
</script>

<style scoped>
.v2-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  flex-wrap: wrap;
  margin-bottom: var(--space-4);
}

.v2-section-header__text {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
  flex: 1 1 auto;
}

.v2-section-header__eyebrow {
  margin: 0;
}

.v2-section-header__title {
  margin: 0;
}

.v2-section-header__description {
  max-width: 640px;
  margin: 0;
}

.v2-section-header__actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;
}
</style>
